<template>
<div>

  <div class="header-banner">
    <section class="section header-block">
      <div class="container">
      <h1>{{ blog.title }}</h1>
    </div>
  </section>
  </div>

  <section class="section">
    <div class="container">
      
      <div class="columns">
        <div class="column is-two-thirds">

          <img :src="'/images/blogs/' + blog.mainimage" :alt="blog.title" class="bordered-image row-image img-fluid">

          <div class="product-info block-with-vsmall-vertical-gap">
            <h5 class="title is-4 block-with-vsmall-vertical-gap">
                {{ blog.title }}
            </h5>
            <div class="block-with-small-vertical-gap">
              <p class="">by {{ blog.author }}</p>
              <p>{{ prettifydate(blog.order) || prettifydate(blog.createdAt) }}</p>
            </div>

            <div class="content block-with-medium-vertical-gap">
              <p v-html="blog.body" />
            </div>

          </div>
        </div>

        <mq-layout mq="md+">
          <div class="column">
              <h4 class="title">Blogs list</h4>
              <div v-for="item in blogslist" :key="item._id">
                <router-link tag="a" :to="{name: 'blog', params: {slug: item.slug}}">
                  {{ item.title }}
                </router-link>
              </div>
          </div>
        </mq-layout>

      </div>

      <div class="photos" v-if="blog.images">
        <div v-if="blog.images.length > 0">
          <ul>
            <li class="nav-item" v-for="image in blog.images" :key="image._id">
                <a :href="'/images/blogs/' + image.photo" :alt="image.caption" :title="image.caption">
                  <img :src="'/images/blogs/' + image.photo" />
                </a>
            </li>
          </ul>
        </div> 
      </div>

    </div>
  </section>

</div>
</template>

<script>
//import ProductShopRows from './productShopEventRows/ProductShopRows';
import Api from '@/config/Api'
//import mixins from '@/mixins/mixins'

import { mapGetters, mapState } from 'vuex'
var moment = require('moment');
//import mixins from '@/mixins/mixins';
// import Api from '@/config/Api'; // MCH added

// import AlertMeButton from './AlertMeButton';
// import MaxPriceWidget from './MaxPriceWidget';

export default {
  props: ['slug'],
  //mixins: [mixins],
  components: {
    /*ProductShopRows,
    ProductEventRows,
    AlertMeButton,
    MaxPriceWidget*/
  },
  data(){
    return {
      blog: {
        title: '',
      },
      blogslist: [{
        title: '',
        slug: '/'
      }]
    }
  },
  computed: {
    ...mapGetters(['getProfile', 'isAuthenticated', 'isProfileLoaded']),
    /* ...mapState({
      authLoading: state => state.status === 'loading',
      name: state => `${state.user.profile.name}`, 
    }) */
  },
  created() { 

    console.log("created");
    
    Api().get(`/api/blogs/${this.slug}`).then(response => {
      this.blog = response.data;
      this.$store.commit('setContentLoaded', true); // then footer will be displayed
    });
    Api().get(`/api/blogs`).then(response => {
      this.blogslist = response.data.blogs;
    });
  },
  updated() {
    console.log("updated");
  },
  /* mounted() {
    console.log("mounted");
    //this.listenToEvents();
  }, */
  methods: {
      prettifydate(date) {
          if (!date) return;
          return moment(date).format("dddd, Do MMMM YYYY");
      }
  },
  metaInfo () {
    return {
      title: this.blog.title,
      // titleTemplate: null // override the parent template and just use the above title only
    }
  }
  
}
</script>

<style>
.hidden {
  display: none;
}
.visible {
  display: block;
}
.realtime-message-container {
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  padding: 1rem;
}
.spinner {
  display: inline-block;
}
.realtime-message1 {
}
.realtime-message2 {
  display: block;
  /* line-height: 1.8em; */
  white-space: normal;
}
#ball-spinner {
  position: relative;
  right: .2em;
  top: .3em;
}
.toggleButton {
  text-align: center;
  margin: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Blog.vue